import React, { useState } from "react";
import Ajv from "ajv/dist/2019.js";
import addFormats from "ajv-formats";

// Własna kopia meta-schematu (draft-2019-09) i schemat OB 3.0
import metaSchema2019 from "./draft-2019-09.json";
import schema from "./ob_v3p0_achievementcredential_schema.json";

import {
    Box,
    Typography,
    Button
} from "@mui/material";

const ajv = new Ajv({ allErrors: true, strict: false });
addFormats(ajv);
if (!ajv.getSchema("OpenBadgeCredential")) {
    ajv.addSchema(schema, "OpenBadgeCredential");
}
function ValidateBadgeOB3({ setShow, badge }) {
    const [validationErrors, setValidationErrors] = useState([]);
    const [isValid, setIsValid] = useState(null);

    const handleValidation = () => {
        const validate = ajv.getSchema("OpenBadgeCredential");

        if (!validate) {
            setIsValid(false);
            setValidationErrors([
                { message: "Nie można znaleźć schematu walidacji." }
            ]);
            return;
        }

        const valid = validate(badge);
        setIsValid(valid);

        if (!valid) {
            setValidationErrors(validate.errors || []);
        } else {
            setValidationErrors([]);
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: "white",
                margin: "auto",
                padding: 4,
                maxWidth: 600,
                borderRadius: 2,
                mt: 10,
                textAlign: "center",
            }}
        >
            <Typography variant="h6" gutterBottom>
                Weryfikacja Open Badge 3.0
            </Typography>

            <Button variant="contained" sx={{ mt: 2 }} onClick={handleValidation}>
                Sprawdź poprawność
            </Button>

            {isValid !== null && (
                <Typography sx={{ mt: 3 }} color={isValid ? "success.main" : "error.main"}>
                    {isValid
                        ? "✔ Odznaka jest zgodna ze schematem OB 3.0."
                        : "✖ Odznaka nie jest zgodna z OB 3.0."}
                </Typography>
            )}

            {!isValid && validationErrors.length > 0 && (
                <Box sx={{ textAlign: "left", mt: 2 }}>
                    <Typography variant="subtitle1">Błędy walidacji:</Typography>
                    <ul>
                        {validationErrors.map((err, idx) => (
                            <li key={idx}>
                                <Typography variant="body2">
                                    {err.instancePath ? `${err.instancePath} ` : ""}
                                    {err.message}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                </Box>
            )}

            <Button variant="outlined" sx={{ mt: 4 }} onClick={() => setShow(false)}>
                Zamknij
            </Button>
        </Box>
    );
}

export default ValidateBadgeOB3;
